import { makeEditableDateCell } from "./WorkEditableDateCell";

/** The Work end column's cell. */
export const WorkDeliveryDateCell = makeEditableDateCell("workDeliveryDate");
WorkDeliveryDateCell.displayName = "WorkDeliveryDateCell";
